import { render, staticRenderFns } from "./HsabExpenseCardColumns.vue?vue&type=template&id=6991b44e&scoped=true"
import script from "./HsabExpenseCardColumns.vue?vue&type=script&lang=ts"
export * from "./HsabExpenseCardColumns.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6991b44e",
  null
  
)

export default component.exports